import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledButtonProps } from './CtaButton.types';

export const StyledButton = styled.button<IStyledButtonProps>`
  display: inline-block;
  ${({ width }) =>
    width?.toString().endsWith('px')
      ? `width: ${rem(width)};`
      : `width: ${width};`}
  padding: ${({ theme }) =>
    `${rem(theme.spacings.s)} ${rem(theme.spacings.m)}`};
  font-size: ${rem('14px')};
  font-weight: 700;
  letter-spacing: ${rem('0.4px')};
  line-height: 100%;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  border: 1px solid ${({ theme, user }) => user && theme.colors[user].main};
  border-radius: ${({ theme }) => rem(theme.spacings.xs)};

  ${({ theme, user, variant }) =>
    variant === 'primary' &&
    `
    color: ${theme.colors.main};
    background-color: ${user && theme.colors[user].main};
    box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.25) inset;
  `}

  ${({ theme, user, variant }) =>
    variant === 'secondary' &&
    `
    color: ${user && theme.colors[user].main};
    background-color: ${theme.colors.main};
  `}

  &:hover:not(:disabled) {
    ${({ theme, user, variant }) =>
      variant === 'primary' &&
      `
    background-color: ${user && theme.colors[user].mainAlternate};
  `}

    ${({ theme, user, variant }) =>
      variant === 'secondary' &&
      `
    border-color: ${user && theme.colors[user].mainAlternate};
  `}
  }

  &:disabled {
    cursor: default;
    opacity: 0.3;
  }
`;
